import axios from 'axios';
import Cookies from 'universal-cookie';
import uuidv4 from 'uuid/v4';
import { browserName, fullBrowserVersion, deviceType } from 'react-device-detect';
import { GATEWAY_CHANNEL_TYPES } from 'Store/constants/sportTypes';
import LocalStorage from 'Utils/localStorage';
import ProjectConfig from 'ProjectConfig';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

if (typeof window === 'undefined') {
  axios.defaults.baseURL = API_GATEWAY;
} else {
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  
  if (isLocalhost) {
    const useProxy = !API_GATEWAY.includes('www.bilyoner.com');
    axios.defaults.baseURL = useProxy ? '' : API_GATEWAY;
  } else {
    axios.defaults.baseURL = API_GATEWAY;
  }
}

const setAuthToken = accessToken => {
  if (accessToken) {
    axios.defaults.headers.common['X-Auth-Token'] = accessToken;
  }
};

const removeAuthToken = () => {
  delete axios.defaults.headers.common['X-Auth-Token'];
};

const hasAuthToken = () => !!axios.defaults.headers.common['X-Auth-Token'];

const setUniqueDeviceId = () => {
  const cookies = new Cookies();
  let uniqueDeviceID = cookies.get('uniqueDeviceID');

  if (!uniqueDeviceID) {
    uniqueDeviceID = uuidv4().toUpperCase();
    cookies.set('uniqueDeviceID', uniqueDeviceID, { path: '/', expires: new Date(Date.now() + 200000000000) });
    axios.defaults.headers.common['X-DEVICE-ID'] = uniqueDeviceID;
  }

  axios.defaults.headers.common['X-DEVICE-ID'] = uniqueDeviceID;
  setOtherDefaultHeaders();
};

const setOtherDefaultHeaders = () => {
  const appVersion = ProjectConfig?.version || LocalStorage.get('version');
  
  axios.defaults.headers.common['X-CLIENT-CHANNEL'] = GATEWAY_CHANNEL_TYPES[deviceType];
  axios.defaults.headers.common['X-CLIENT-BROWSER-VERSION'] = `${browserName} / v${fullBrowserVersion}`;
  axios.defaults.headers.common['X-CLIENT-APP-VERSION'] = appVersion;
  axios.defaults.headers.common['PLATFORM-TOKEN'] = ProjectConfig.PLATFORM_TOKEN;

};

export {
  setAuthToken,
  removeAuthToken,
  hasAuthToken,
  setUniqueDeviceId,
  setOtherDefaultHeaders
};
